import { sessionStats } from "../actions/onLoadFunctionAction";
import { getRoom } from "../components/Twilio/Room/roomService";
import reduxStore from "../configureEnvStore";
import { CALL_DATA } from "../constants/PublicVariables";
import { setCallStatsStarted } from "../reducers/callstats-reducer";
import { LogFirebase } from "./firestore";

class CallStatsService {
    currTimeStamp = null;
    callStatsJson = null;

    getRemotePartiObject() {
        return {
            MMID: "",
            ROOMSID: "",
            NETWORKQUALITY: "",
            REMOTEVIDEOSTATS: {
                HEIGHT: "",
                WIDTH: "",
                FRAMERATE: "",
                BYTESRECEIVED: "",
                PACKETSRECEIVED: "",
                CODEC: "",
                PACKETSLOST: "",
                SSRC: "",
                TIMESTAMP: "",
                TRACKID: "",
            },
            REMOTEAUDIOSTATS: {
                AUDIOLEVEL: "",
                JITTER: "",
                BYTESRECEIVED: "",
                PACKETSRECEIVED: "",
                CODEC: "",
                PACKETSLOST: "",
                SSRC: "",
                TRACKID: "",
                TIMESTAMP: "",
            },
        };
    }

    getCallstatsObject() {
        return {
            TIMESTAMP: "",
            MMID: "",
            ROOMSID: "",
            LOCALPARTICIPANTS: [
                {
                    MMID: "",
                    ROOMSID: "",
                    NETWORKQUALITY: "",
                    NETWORKSPEED: "",
                    NETWORKTYPE: "",
                    LOCALVIDEOSTATS: {
                        BYTESSENT: "",
                        CODEC: "",
                        FRAMERATE: "",
                        HEIGHT: "",
                        TIMESTAMP: "",
                        WIDTH: "",
                        PACKETSLOST: "",
                        PACKETSSENT: "",
                        NETWORKQUALITY: "",
                        CAPTUREDFRAMERATE: "",
                        CAPTUREDHEIGHT: "",
                        CAPTUREDWIDTH: "",
                        SSRC: "",
                        TRACKID: "",
                        ROUNDTRIPTIME: "",
                    },
                    LOCALAUDIOSTATS: {
                        AUDIOLEVEL: "",
                        JITTER: "",
                        BYTESSENT: "",
                        PACKETSSENT: "",
                        ROUNDTRIPTIME: "",
                        TIMESTAMP: "",
                        CODEC: "",
                        PACKETSLOST: "",
                        SSRC: "",
                        TRACKID: "",
                        NETWORKQUALITY: "",
                    },
                },
            ],
            REMOTEPARTICIPANTS: [],
            ICECANDIDATESTATS: null,
            ICECANDIDATEPAIRSTATS: null,
        };
    }

    initCallStats() {
        try {
            this.callStatsJson = {};
            let callStatObj = this.getCallstatsObject();
            this.callStatsJson = this.jsonClone(callStatObj);
        } catch (err) {
            console.log("CALL STATS ERROR:" + err?.message);
            LogFirebase("_callStatsInit_error", err?.message);
        }
    }

    setCallStatsInfo() {
        try {
            const room = getRoom();
            if (room) {
                const { participantCount } = reduxStore.getState().commonReducer;
                //set generalinfo
                this.callStatsJson.TIMESTAMP = new Date().getTime();
                this.callStatsJson.MMID = parseInt(CALL_DATA.memberId);
                this.callStatsJson.ROOMSID = CALL_DATA.roomSID;
                this.callStatsJson.LOCALPARTICIPANTS[0].MMID = parseInt(CALL_DATA.memberId);
                this.callStatsJson.LOCALPARTICIPANTS[0].ROOMSID = CALL_DATA.roomSID;
                this.callStatsJson.LOCALPARTICIPANTS[0].NETWORKQUALITY = "";
                this.callStatsJson.LOCALPARTICIPANTS[0].NETWORKSPEED = CALL_DATA.callstatsNetSpeed.toUpperCase();
                this.callStatsJson.LOCALPARTICIPANTS[0].NETWORKTYPE = CALL_DATA.callstatsNetType.toUpperCase();

                //even if local audio-video stats not available, set timestamp
                this.callStatsJson.LOCALPARTICIPANTS[0].LOCALAUDIOSTATS.TIMESTAMP = this.callStatsJson.TIMESTAMP;
                this.callStatsJson.LOCALPARTICIPANTS[0].LOCALVIDEOSTATS.TIMESTAMP = this.callStatsJson.TIMESTAMP;
                let cntr = 0;
                //init remote parti object
                let remoteParticipantJson = this.getRemotePartiObject();
                this.callStatsJson.REMOTEPARTICIPANTS = [];
                if (participantCount <= 2) {
                    this.callStatsJson.REMOTEPARTICIPANTS[cntr++] = this.jsonClone(remoteParticipantJson);
                } else {
                    for (let i = 0; i < participantCount - 1; i++) {
                        this.callStatsJson.REMOTEPARTICIPANTS[i] = this.jsonClone(remoteParticipantJson);
                    }
                }
                //set remote basic info
                cntr = 0;
                room?.participants?.forEach((remoteParticipant, val) => {
                    let mmid = "";
                    remoteParticipant.dataTracks.forEach((track, val4) => {
                        mmid = track.trackName.substr(2, track.trackName.length);
                    });
                    if (this.callStatsJson.REMOTEPARTICIPANTS[cntr]) {
                        this.callStatsJson.REMOTEPARTICIPANTS[cntr].MMID = mmid;
                        this.callStatsJson.REMOTEPARTICIPANTS[cntr].ROOMSID = CALL_DATA.roomSID;
                        this.callStatsJson.REMOTEPARTICIPANTS[cntr].NETWORKQUALITY = remoteParticipant.networkQualityLevel;
                    }
                    cntr++;
                });
            } else {
                console.error("setCallStatsInfo : room not available");
            }
        } catch (err) {
            console.error("CALL STATS ERROR:" + err.message);
            LogFirebase("_callStatsSet_error", err.message);
        }
    }

    setLocalAudioStats = (localAudioTracksStats, localParticipant) => {
        try {
            let localAudio = {
                AUDIOLEVEL: localAudioTracksStats ? localAudioTracksStats.audioLevel : "",
                JITTER: localAudioTracksStats ? localAudioTracksStats.jitter : "",
                BYTESSENT: localAudioTracksStats ? localAudioTracksStats.bytesSent : "",
                PACKETSSENT: localAudioTracksStats ? localAudioTracksStats.packetsSent : "",
                ROUNDTRIPTIME: localAudioTracksStats ? localAudioTracksStats.roundTripTime : "",
                CODEC: localAudioTracksStats ? localAudioTracksStats.codec : "",
                PACKETSLOST: localAudioTracksStats ? localAudioTracksStats.packetsLost : "",
                SSRC: localAudioTracksStats ? localAudioTracksStats.ssrc : "",
                TRACKID: localAudioTracksStats ? localAudioTracksStats.trackId : "",
                NETWORKQUALITY: localParticipant.networkQualityLevel || "",
                TIMESTAMP: this.callStatsJson.TIMESTAMP || "",
            };

            this.callStatsJson.LOCALPARTICIPANTS[0].LOCALAUDIOSTATS = localAudio;
        } catch (err) {
            console.error("CALL STATS ERROR:" + err.message);
            LogFirebase("_callStatsLocalAudio_error", err.message);
        }
    };

    setLocalVideoStats = (localVideoTracksStats, localParticipant) => {
        try {
            let localVideo = {
                BYTESSENT: "",
                CODEC: "",
                FRAMERATE: "",
                HEIGHT: "",
                WIDTH: "",
                PACKETSLOST: "",
                PACKETSSENT: "",
                NETWORKQUALITY: "",
                CAPTUREDFRAMERATE: "",
                CAPTUREDHEIGHT: "",
                CAPTUREDWIDTH: "",
                SSRC: "",
                TRACKID: "",
                ROUNDTRIPTIME: "",
                TIMESTAMP: "",
            };
            if (localVideoTracksStats) {
                localVideo.BYTESSENT = localVideoTracksStats.bytesSent;
                localVideo.CODEC = localVideoTracksStats.codec;
                localVideo.FRAMERATE = localVideoTracksStats.frameRate;
                if (localVideoTracksStats.dimensions) {
                    localVideo.HEIGHT = localVideoTracksStats.dimensions.height;
                    localVideo.WIDTH = localVideoTracksStats.dimensions.width;
                }
                localVideo.PACKETSLOST = localVideoTracksStats.packetsLost;
                localVideo.PACKETSSENT = localVideoTracksStats.packetsSent;
                localVideo.CAPTUREDFRAMERATE = localVideoTracksStats.captureFrameRate;
                if (localVideoTracksStats.captureDimensions) {
                    localVideo.CAPTUREDHEIGHT = localVideoTracksStats.captureDimensions.height;
                    localVideo.CAPTUREDWIDTH = localVideoTracksStats.captureDimensions.width;
                }
                localVideo.SSRC = localVideoTracksStats.ssrc;
                localVideo.TRACKID = localVideoTracksStats.trackId;
                localVideo.ROUNDTRIPTIME = localVideoTracksStats.roundTripTime;
            }
            localVideo.NETWORKQUALITY = localParticipant.networkQualityLevel;
            localVideo.TIMESTAMP = this.callStatsJson.TIMESTAMP;
            this.callStatsJson.LOCALPARTICIPANTS[0].LOCALVIDEOSTATS = localVideo;
        } catch (err) {
            console.error("CALL STATS ERROR:" + err.message);
            LogFirebase("_callStatsLocalVideo_error", err.message);
        }
    };

    setRemoteStats = (allParti, statsreport) => {
        try {
            //stats for all participants
            let cntr = 0;
            let partiAudio = {};
            let partiVideo = {};
            allParti.forEach((participant, id) => {
                partiAudio = {
                    AUDIOLEVEL: "",
                    JITTER: "",
                    BYTESRECEIVED: "",
                    PACKETSRECEIVED: "",
                    CODEC: "",
                    PACKETSLOST: "",
                    SSRC: "",
                    TRACKID: "",
                    TIMESTAMP: "",
                };
                partiVideo = {
                    HEIGHT: "",
                    WIDTH: "",
                    FRAMERATE: "",
                    BYTESRECEIVED: "",
                    PACKETSRECEIVED: "",
                    CODEC: "",
                    PACKETSLOST: "",
                    SSRC: "",
                    TRACKID: "",
                    TIMESTAMP: "",
                };

                this.callStatsJson.REMOTEPARTICIPANTS[cntr].MMID = participant?.MMID;
                this.callStatsJson.REMOTEPARTICIPANTS[cntr].ROOMSID = participant?.ROOMSID;
                this.callStatsJson.REMOTEPARTICIPANTS[cntr].NETWORKQUALITY = participant?.NETWORKQUALITY;
                //set time stamp even if audio-video stats not available.
                this.callStatsJson.REMOTEPARTICIPANTS[cntr].REMOTEAUDIOSTATS.TIMESTAMP = this.callStatsJson.TIMESTAMP;
                this.callStatsJson.REMOTEPARTICIPANTS[cntr].REMOTEVIDEOSTATS.TIMESTAMP = this.callStatsJson.TIMESTAMP;
                if (statsreport.remoteAudioTrackStats && statsreport.remoteAudioTrackStats.length > 0) {
                    statsreport.remoteAudioTrackStats.forEach((remoteATrackStats, val3) => {
                        if (remoteATrackStats.trackSid == participant.ADOTRACKSID) {
                            partiAudio.AUDIOLEVEL = remoteATrackStats.audioLevel;
                            partiAudio.JITTER = remoteATrackStats.jitter;
                            partiAudio.BYTESRECEIVED = remoteATrackStats.bytesReceived;
                            partiAudio.PACKETSRECEIVED = remoteATrackStats.packetsReceived;
                            partiAudio.CODEC = remoteATrackStats.codec;
                            partiAudio.PACKETSLOST = remoteATrackStats.packetsLost;
                            partiAudio.SSRC = remoteATrackStats.ssrc;
                            partiAudio.TRACKID = remoteATrackStats.trackId;
                            partiAudio.TIMESTAMP = this.callStatsJson.TIMESTAMP;
                            this.callStatsJson.REMOTEPARTICIPANTS[cntr].REMOTEAUDIOSTATS = partiAudio;
                        }
                    });
                } else {
                    partiAudio.TIMESTAMP = this.callStatsJson.TIMESTAMP;
                    this.callStatsJson.REMOTEPARTICIPANTS[cntr].REMOTEAUDIOSTATS = partiAudio;
                }
                if (statsreport.remoteVideoTrackStats && statsreport.remoteVideoTrackStats.length > 0) {
                    statsreport.remoteVideoTrackStats.forEach((remoteVTrackStats, val2) => {
                        if (remoteVTrackStats.trackSid == participant.VDOTRACKSID) {
                            if (remoteVTrackStats.dimensions) {
                                partiVideo.HEIGHT = remoteVTrackStats.dimensions.height;
                                partiVideo.WIDTH = remoteVTrackStats.dimensions.width;
                            }
                            partiVideo.FRAMERATE = remoteVTrackStats.frameRate;
                            partiVideo.BYTESRECEIVED = remoteVTrackStats.bytesReceived;
                            partiVideo.PACKETSRECEIVED = remoteVTrackStats.packetsReceived;
                            partiVideo.CODEC = remoteVTrackStats.codec;
                            partiVideo.PACKETSLOST = remoteVTrackStats.packetsLost;
                            partiVideo.SSRC = remoteVTrackStats.ssrc;
                            partiVideo.TRACKID = remoteVTrackStats.trackId;
                            partiVideo.TIMESTAMP = this.callStatsJson.TIMESTAMP;
                            this.callStatsJson.REMOTEPARTICIPANTS[cntr].REMOTEVIDEOSTATS = partiVideo;
                        }
                    });
                } else {
                    partiVideo.TIMESTAMP = this.callStatsJson.TIMESTAMP;
                    this.callStatsJson.REMOTEPARTICIPANTS[cntr].REMOTEVIDEOSTATS = partiVideo;
                }
                cntr++;
            });
        } catch (err) {
            console.error("CALL STATS ERROR:" + err.message);
            LogFirebase("_callStatsRemote_error", err.message);
        }
    };

    jsonClone(obj) {
        return JSON.parse(JSON.stringify(obj));
    }

    sendStatsData() {
        reduxStore.dispatch(sessionStats(this.callStatsJson));
    }

    callStats(toDestroy) {
        let callStatsIntervalPromise;
        let statsParticipantsList = {};
        let callStatsAvailable = false;

        // Call stats the first time
        const room = getRoom();
        this.setCallStatsInfo(room);
        this.sendStatsData();

        if (!toDestroy) {
            // Set interval to fetch stats periodically
            callStatsIntervalPromise = setInterval(() => {
                const room = getRoom();
                statsParticipantsList = {};

                if (room) {
                    this.setCallStatsInfo(room);

                    room.getStats()
                        .then((statsreport) => {
                            try {
                                reduxStore.dispatch(setCallStatsStarted(true));
                                if (statsreport[0]) {
                                    callStatsAvailable = true;

                                    // Local stats
                                    this.setLocalAudioStats(statsreport[0].localAudioTrackStats[0], room.localParticipant);
                                    this.setLocalVideoStats(statsreport[0].localVideoTrackStats[0], room.localParticipant);

                                    const allParti = [];
                                    room?.participants?.forEach((remoteParticipant, val) => {
                                        let trackName = "";
                                        statsParticipantsList = {};
                                        statsParticipantsList["NETWORKQUALITY"] = remoteParticipant.networkQualityLevel;
                                        statsParticipantsList["ROOMSID"] = room.sid;
                                        //audio sid
                                        remoteParticipant.audioTracks.forEach((track, val3) => {
                                            trackName = track.trackName.substr(2, track.trackName.length);
                                            statsParticipantsList["MMID"] = trackName;
                                            statsParticipantsList["ADOTRACKSID"] = track.trackSid;
                                        });
                                        //video sid
                                        remoteParticipant.videoTracks.forEach((track, val2) => {
                                            if (trackName == "") {
                                                //if no vdotracks then MMID will not be there
                                                if (!statsParticipantsList["MMID"]) {
                                                    trackName = track.trackName.substr(2, track.trackName.length);
                                                    statsParticipantsList["MMID"] = trackName;
                                                }
                                                statsParticipantsList["MMID"] = trackName;
                                            }
                                            statsParticipantsList["VDOTRACKSID"] = track.trackSid;
                                        });
                                        //fetch MMID from datatracks > trackname
                                        if (trackName == "") {
                                            remoteParticipant.dataTracks.forEach((track, val4) => {
                                                trackName = track.trackName.substr(2, track.trackName.length);
                                                statsParticipantsList["MMID"] = trackName;
                                            });
                                        }
                                        allParti.push(statsParticipantsList);
                                    });

                                    // Remote stats
                                    this.setRemoteStats(allParti, statsreport[0]);
                                    this.sendStatsData();
                                }
                            } catch (err) {
                                console.error("Error in callStats processing:", err.message);
                                LogFirebase("_callStats_error", err.message);
                            }
                        })
                        .catch((err) => {
                            console.error("Error fetching stats:", err);
                            LogFirebase("_callStatsGet_error", err.message);
                        });

                    // Send data to backend even if no stats are available
                    if (!callStatsAvailable) {
                        this.sendStatsData();
                    }
                } else {
                    if (reduxStore.getState().commonReducer.isRemoteParticipantJoined) {
                        LogFirebase("_callStats_error", "room is undefined");
                    }
                    console.warn("Room is undefined. Cancelling interval.");
                    clearInterval(callStatsIntervalPromise);
                }
            }, 10000);
        } else {
            // Clear interval if toDestroy is true
            clearInterval(callStatsIntervalPromise);
        }
    }
}

export default new CallStatsService();
